<div>Customer:</div>
<div>{{ [orderInfo.name1, orderInfo.name2] | join:" " }}</div>
<div>{{ orderInfo.street }}</div>
<div>{{ orderInfo.city }}</div>
<div>{{ orderInfo.region }} {{ orderInfo.postcode }}</div>
